import React from 'react';

import { Redirect, Route, useLocation } from 'react-router-dom';

import { DASHBOARD_PATH, UNAUTHORIZED_BLOCKED_PATH, UNAUTHORIZED_DELETED_PATH } from 'constants/routes';
import { useAccountPath } from 'hooks/useAccountPath';
import { useAuthentication } from 'hooks/useAuthentication';
import noop from 'utils/noop';

import Backdrop from '../shared/Backdrop';
import Loader from '../shared/Loader';

function AuthRoute({ children, getHomepath = noop, getDeletedPath = noop, ...rest }) {
  const { isSent, isAppLoading, isAuthenticated, isUnauthorized, isUserBlocked, isUserDeleted } = useAuthentication();
  const loc = useLocation();
  const getPath = useAccountPath();

  if (isUnauthorized && isUserBlocked) return <Redirect to={{ pathname: UNAUTHORIZED_BLOCKED_PATH }} />;
  if (isUnauthorized && isUserDeleted)
    return <Redirect to={{ pathname: getDeletedPath() ?? UNAUTHORIZED_DELETED_PATH }} />;

  return (
    <Route
      {...rest}
      render={() => {
        if (!isSent || isAppLoading) {
          return (
            <Backdrop isOpen>
              <Loader />
            </Backdrop>
          );
        }

        return isAuthenticated ? (
          <Redirect to={{ pathname: loc?.state?.from?.pathname || getHomepath() || getPath(DASHBOARD_PATH) }} />
        ) : (
          children
        );
      }}
    />
  );
}

export default AuthRoute;
